import { configureStore } from "@reduxjs/toolkit";
import React from "react";
import { TypedUseSelectorHook, createDispatchHook, createSelectorHook } from "react-redux";
import iceSlice from "./iceSlice";
import roomosSlice from "./roomosSlice";

export const SpacesContext = React.createContext(null);

const spacesStore = configureStore({
    reducer: {
        iceStore: iceSlice,
        roomosStore: roomosSlice,
    },
});
export default spacesStore;

export type State = ReturnType<typeof spacesStore.getState>;
export type Dispatch = typeof spacesStore.dispatch;
export const useSpacesSelector: TypedUseSelectorHook<State> = createSelectorHook(SpacesContext);
export const useSpacesDispatch = createDispatchHook<Dispatch>(SpacesContext);
